import styled from 'styled-components';
import { CheckboxOld, Tooltip, TextInput } from 'shared/components';
import { ThickCheckmark as CheckmarkIcon } from 'src/svg/thick-checkmark';

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 32px;
`;

export const Container = styled.div`
  border-top: solid 1px #d7e4eb;
  padding-top: 45px;
`;

export const FieldTitle = styled.label`
  text-transform: uppercase;
  font-size: 11px;
  font-weight: bold;
  color: #969ea5;
  display: inline-block;
`;

export const FieldTitleContainer = styled.div`
  display: flex;
  align-items: centers;
  margin-bottom: 7px;
`;

export const StyledCheckbox = styled(CheckboxOld)`
  display: inline-flex;
  margin-right: 24px;
  margin-top: 7px;
  > span {
    font-size: 13px;
    color: #6d747b;
  }
`;

export const StyledCheckmarkIcon = styled(CheckmarkIcon)`
  margin: 0 0 4px 4px;
`;

export const OptionsCheckboxGroupContainer = styled.div`
  margin-bottom: 25px;
`;

export const StyledTextInput = styled(TextInput)`
  width: 100%;
  height: 47px;
  border-radius: 3px;
  margin: 0;
`;

export const StyledTooltip = styled(Tooltip)`
  display: inline-flex;
  margin-bottom: 2px;
`;

export const CarouselThemeSection = styled.section`
  border-top: 1px solid #d7e4eb;
  margin: 8px 0 32px;
  padding-top: 24px;
`;

export const CarouselThemeTitle = styled.h3`
  color: #4f5d68;
  font-size: 14px;
  margin: 0 0 6px;
`;

export const CarouselThemeDescription = styled.p`
  color: #6d747b;
  font-size: 13px;
  line-height: 18px;
  margin: 0 0 18px;
`;

export const CarouselThemeColorGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 20px;

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const CarouselThemeControl = styled.div`
  min-width: 0;

  ${StyledCheckbox} {
    margin-bottom: 7px;
    margin-top: 0;
  }
`;

export const CarouselThemeSelectGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ThemeColorValueRow = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const ThemeColorInput = styled.input`
  background: transparent;
  border: 1px solid #d3d8de;
  border-radius: 4px;
  cursor: pointer;
  height: 34px;
  padding: 2px;
  width: 44px;
`;

export const ThemeColorValue = styled.span`
  color: #4f5d68;
  font-family: monospace;
  font-size: 13px;
`;
